export const GET_USERSADMIN = "GET_USERSADMIN";
export const GET_USERADMIN_LIST_TYPE_DOCUMENT = "GET_USERADMIN_LIST_TYPE_DOCUMENT";
export const GET_USERADMIN_LIST_TYPE_ROL = "GET_USERADMIN_LIST_TYPE_ROL";
export const GET_STATE_LOADING = "GET_STATE_LOADING";  
export const GET_USER_ADMIN_ID = "GET_USER_ADMIN_ID";
export const GET_USER_ADMIN_COMPANY_ID = "GET_USER_ADMIN_COMPANY_ID";
export const GET_STARASSIGNMENT_SEARCHAFFILIATES = "GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const GET_USERSTATUS = "GET_USERSTATUS";
export const GET_AFFILIATEDUSERS_LIST_GENDER = "GET_AFFILIATEDUSERS_LIST_GENDER"